import {
  SET_BUSINESS_INFO,
  SET_ACTIVATION,
  SET_CHARGE_TYPE,
  SET_CHARGE,
  CLEAR_CHARGE,
  SET_SUPERLOGICA_LIST,
  HANDLE_LOADING,
  CLEAR_BUSINESS_INFO_REGISTRATION
} from './constants';

export const setBusinessInfo = data => ({
  type: SET_BUSINESS_INFO,
  data
});

export const setActivation = data => ({
  type: SET_ACTIVATION,
  data
});

export const setChargeType = chargeType => ({
  type: SET_CHARGE_TYPE,
  chargeType
});

export const setCharge = data => ({
  type: SET_CHARGE,
  data
});

export const clearCharge = () => ({
  type: CLEAR_CHARGE
});

export const setSuperlogicaList = data => ({
  type: SET_SUPERLOGICA_LIST,
  data
});

export const handleLoading = status => ({
  type: HANDLE_LOADING,
  status
});

export const clearBusinessInfoRegistration = () => ({
  type: CLEAR_BUSINESS_INFO_REGISTRATION
});